import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppConfig, usePermissions } from '@ltvco/refresh-lib/ctx';
import { useFirstRecordSearchRedirect } from '@ltvco/refresh-lib/utils';
import { getFreemiumSubscribePageData } from '../utils/freemiumSubscribePageStorage';

export const useFirstRecordSearch = (account: unknown) => {
  const navigate = useNavigate();
  const { routingUtils } = useContext(AppConfig);
  const { isFreePlan } = usePermissions();

  const freemiumSubscribePageData = getFreemiumSubscribePageData();
  const comesFromSkipSubscribePageFlow = freemiumSubscribePageData.skip_page;

  useFirstRecordSearchRedirect({
    account,
    routingUtils,
    navigate,
    beforeRedirect: () => {
      const hasSkippedSubscribePage =
        (account as any)?.account?.user_settings
          ?.hide_freemium_upgrade_prompt === true;

      if (
        isFreePlan &&
        !hasSkippedSubscribePage &&
        !comesFromSkipSubscribePageFlow
      ) {
        navigate('/subscribe');
        return false;
      }
    },
  });
};
